import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/Dialog": Dialog, "@mui/material/DialogActions": DialogActions, "@mui/material/DialogContent": DialogContent, "@mui/material/DialogContentText": DialogContentText, "@mui/material/DialogTitle": DialogTitle, "@mui/material/Snackbar": Snackbar } } });
export default ClientProvider;
